import React from "react";

import DesignAfter1mage from "assets/desktop-research/svgs/design-after.svg";
import DesignBefore1mage from "assets/desktop-research/svgs/design-befor.svg";
import Frame1mage from "assets/desktop-research/images/frame1.png";
import Frame2mage from "assets/desktop-research/images/frame2.png";
import ResearchReasonBg1mage from "assets/desktop-research/images/research-reason-bg.png";
import { useTranslation } from "react-i18next";

const ReasonForResearch = () => {
  const { t } = useTranslation("event");

  return (
    <div className="flex justify-center items-center mt-[13rem] relative">
      <img
        src={Frame1mage}
        alt="Frame1mage"
        className="w-[100px] h-[140px] absolute top-[-250px] left-[48%]"
      />
      <div className="flex justify-center items-center flex-col gap-20 relatve md:w-[90%] xl:w-[92%]">
        <div className="flex justify-center items-center gap-3 w-full">
          <img
            src={DesignBefore1mage}
            alt="DesignBefore1mage"
            className="hidden md:block w-[260px] h-[10px]"
          />
          <h1 className="text-[#334155] text-[30px] xl:text-[48px] font-euclidSemibold font-euclid w-full text-center">
            {t("desktopResearch.researchReason.title")}
          </h1>
          <img
            src={DesignAfter1mage}
            alt="DesignAfter1mage"
            className="hidden lg:block w-[260px] h-[10px]"
          />
          <img
            src={Frame2mage}
            alt="Frame2mage"
            className="w-[97px] h-[44px] absolute top-[4rem] left-[48%]"
          />
        </div>
        <div
          className="md:w-[900px] xl:w-[942px] md:h-[461px] overflow-hidden  bg-cover bg-center relative flex justify-center items-start mt-[2rem] py-10 md:py-0"
          style={{ backgroundImage: `url(${ResearchReasonBg1mage})` }}
        >
          <div className="text-[#202D66] my-10 mx-5 md:m-20 text-xl font-euclidRegular space-y-3">
            <p>{t("desktopResearch.researchReason.desc1")}</p>
            <p>{t("desktopResearch.researchReason.desc2")}</p>
            <p className="font-euclidSemibold">
              {t("desktopResearch.researchReason.desc3")}
            </p>{" "}
            <p>{t("desktopResearch.researchReason.desc4")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReasonForResearch;
